import { render } from "./AccountDiscount.vue?vue&type=template&id=60d11be3&scoped=true"
import script from "./AccountDiscount.vue?vue&type=script&lang=js"
export * from "./AccountDiscount.vue?vue&type=script&lang=js"

import "./AccountDiscount.vue?vue&type=style&index=0&id=60d11be3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d11be3"]])

export default __exports__